import { render, staticRenderFns } from "./Australia.vue?vue&type=template&id=d6b9f872&"
import script from "./Australia.vue?vue&type=script&lang=js&"
export * from "./Australia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6b9f872')) {
      api.createRecord('d6b9f872', component.options)
    } else {
      api.reload('d6b9f872', component.options)
    }
    module.hot.accept("./Australia.vue?vue&type=template&id=d6b9f872&", function () {
      api.rerender('d6b9f872', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/countries/Australia.vue"
export default component.exports